module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/logo.png"),
      "height": "150px"
    }
  }), _vm._v(" "), _c('form', {
    attrs: {
      "id": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.addGreeting($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGreeting.lang),
      expression: "newGreeting.lang"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Language Name"
    },
    domProps: {
      "value": _vm._s(_vm.newGreeting.lang)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newGreeting.lang = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGreeting.text),
      expression: "newGreeting.text"
    }],
    attrs: {
      "type": "text",
      "placeholder": "How do you say hello?"
    },
    domProps: {
      "value": _vm._s(_vm.newGreeting.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newGreeting.text = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "submit",
      "value": "Add Greeting"
    },
    domProps: {
      "value": "Add Greeting"
    }
  })]), _vm._v(" "), _vm._l((_vm.greetings), function(greeting) {
    return _c('h1', [_vm._v(_vm._s(greeting.text))])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2a17ef2e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 15
// module chunks = 2